import React, { useEffect, useState } from 'react';

import ProcurementPoliciesCreateForm from '../../procurement_policies/ProcurementPoliciesCreateForm';
import ProcurementPoliciesEditForm from '../../procurement_policies/ProcurementPoliciesEditForm';
import { useProcurement } from '../context/ProcurementContext';

import NewTile from './NewTile';
import PolicyTile from './PolicyTile';
import SlideOver from './SlideOver';

import { apiClient } from 'Helpers/network';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';

/**
 * IB-701 — Setup > Policy grid. Tiles show real policy data only (method, total_cost, details)
 * with an auto icon colour/code — no invented governance chips, no colour picker. Clicking a tile
 * or "+ New policy" opens the EXISTING policy create/edit form in a slide-over; the grid refetches
 * on save. The store endpoint is the policies collection URL (resource store == collection POST).
 */
const PolicyTiles = () => {
    const { routes } = useProcurement();

    const [policies, setPolicies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(null); // { mode: 'create'|'update', policy }

    const fetchPolicies = () => {
        setLoading(true);
        apiClient
            .get(routes.fetchPoliciesUrl)
            .then(({ data }) => setPolicies(Array.isArray(data) ? data : (data?.policies ?? [])))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchPolicies();
    }, []);

    const closeSlideOver = () => setEditing(null);

    const onSaved = () => {
        closeSlideOver();
        fetchPolicies();
    };

    const isCreate = editing?.mode === 'create';

    return (
        <>
            {loading && !policies.length ? (
                <div className="tw-rounded-lg tw-bg-white tw-shadow-primary tw-px-6 tw-py-6.5">
                    <LoadingSpinner />
                </div>
            ) : (
                <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-3">
                    {policies.map((policy) => (
                        <PolicyTile key={policy.id} policy={policy} onClick={() => setEditing({ mode: 'update', policy })} />
                    ))}
                    <NewTile label={$t('New policy')} onClick={() => setEditing({ mode: 'create', policy: {} })} />
                </div>
            )}

            <SlideOver isOpen={!!editing} onClose={closeSlideOver} title={isCreate ? $t('New policy') : $t('Edit policy')}>
                {editing &&
                    (isCreate ? (
                        <ProcurementPoliciesCreateForm storeUrl={routes.fetchPoliciesUrl} onSuccess={onSaved} fullWidth />
                    ) : (
                        <ProcurementPoliciesEditForm
                            policy={editing.policy}
                            updateUrl={routes.updatePolicyUrl}
                            internalCloseHandler={closeSlideOver}
                            setPolicyIsUpdated={onSaved}
                            request={false}
                        />
                    ))}
            </SlideOver>
        </>
    );
};

export default PolicyTiles;
